import { Formatter } from 'gf-ui'
import Credits from './Credits'
import HomeGradimento from './HomeGradimento'
import HomeQuestionario from './HomeQuestionario'
import ModuloAnamnestico from './ModuloAnamnestico'
import ModuloGradimento from './ModuloGradimento'
import Risultato from './Risultato'
import RisultatoGradimento from './RisultatoGradimento'

export { default as Credits } from './coloneRetto/CreditsColon'
export { default as Home } from './Home'
export { default as ModuloAnamnestico } from './HomeQuestionario'
export { default as Risultato } from './Risultato'
export { default as HomeGradimento } from './HomeGradimento'
export { default as ModuloGradimento } from './ModuloGradimento'
export { default as RisultatoGradimento } from './RisultatoGradimento'

export const TIPOLOGIE = {
    SENOLOGIA:              { KID: 1, DESC: 'Senologia', NAME: 'Senologia', CLASSNAME: 'senologia', URL: 'senologia', URL_QUESTIONARIO: '/modulo-anamnestico' },
    COLON_RETTO:            { KID: 2, DESC: 'Colon retto', NAME: 'ColonRetto', CLASSNAME: 'colon-retto', URL: 'colon-retto', URL_QUESTIONARIO: '/modulo-anamnestico' },
    TICKET_PS_STRANIERI:    { KID: 3, DESC: 'Ticket PS Stranieri', NAME: 'TicketPsStranieri', CLASSNAME: 'ticket-ps-stranieri', URL: 'ticket-ps-stranieri', URL_QUESTIONARIO: '/modulo' },
}

export const PAGINE = {
    HOME: { URL: "/", NAME: "home", COMPONENT: (tipologia) => <HomeQuestionario key={tipologia.KID} tipologia={tipologia} /> },
    QUESTIONARIO: { URL: (tipologia) => tipologia.URL_QUESTIONARIO, NAME: "moduloAnamnestico", COMPONENT: (tipologia) => <ModuloAnamnestico key={tipologia.KID} tipologia={tipologia} /> },
    RISULTATO: { URL: "/risultato", NAME: "risultato", COMPONENT: (tipologia) => <Risultato key={tipologia.KID} tipologia={tipologia} /> },
    HOME_GRADIMENTO: { URL: "/gradimento", NAME: "homeGradimento", COMPONENT: (tipologia) => <HomeGradimento key={tipologia.KID} tipologia={tipologia} /> },
    MODULO_GRADIMENTO: { URL: "/modulo-gradimento", NAME: "moduloGradimento", COMPONENT: (tipologia) => <ModuloGradimento key={tipologia.KID} tipologia={tipologia} /> },
    RISULTATO_GRADIMENTO: { URL: "/risultato-gradimento", NAME: "risultatoGradimento", COMPONENT: (tipologia) => <RisultatoGradimento key={tipologia.KID} tipologia={tipologia} /> },
    CREDITS: { URL: "/credits", NAME: "credits", COMPONENT: (tipologia) => <Credits key={tipologia.KID} tipologia={tipologia} /> }
}

export const formattaOrario = (orario) => {
    const time = orario;
    const hours = Math.floor(time / 100);  // Ottieni le ore
    const minutes = time % 100;

    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);

    const formattedTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    return formattedTime
}

/**
 * Cancella le risposte date a domande che dipendono da risposte non più selezionate
 * @param {Object} dom 
 */
export const annullaRisposteDipendenze = (dom) => {
    // Recupero tutti gli id delle risposte selezionate
    const risposte = Object.keys(dom).map(d => {
        const domanda = dom[d]
        if (domanda.ARR_RISPOSTE.filter(r => Formatter.getBoolean(r.FLG_SELEZIONATA)).length > 0) {
            return domanda.ARR_RISPOSTE.find(r => Formatter.getBoolean(r.FLG_SELEZIONATA)).ID_MA_CSS_D_R
        }
        return undefined
    }).filter(r => r).map(r => r.toString())

    // Se ho risposto a delle domande che dipendono da una risposta non più selezionata
    // deseleziono le risposte date a quelle domande
    Object.keys(dom)
        .map(d => dom[d])
        .filter(d => d.ARR_RIFERIMENTI.length > 0)
        .forEach(d => {
            if (d.ARR_RIFERIMENTI.filter(rif => risposte.indexOf(rif.ID_MA_CSS_D_R.toString()) < 0).length > 0 && d.ARR_RISPOSTE.filter(risposta => Formatter.getBoolean(risposta.FLG_SELEZIONATA) || !Formatter.isStringaVuota(risposta.VALORE)).length > 0) {
                Object.keys(dom).forEach(key => {
                    let domandaDaResettare = dom[key]
                    if (domandaDaResettare.KID === d.KID) {
                        domandaDaResettare.ARR_RISPOSTE = domandaDaResettare.ARR_RISPOSTE.map(ris => ({ ...ris, FLG_SELEZIONATA: 0, VALORE: "" }))
                        delete domandaDaResettare.val
                    }
                })
            }
        })
}

export const validateEmail = (value) => {
    // Richiede un dominio completo con TLD (es. .com, .it)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return emailRegex.test(value);
}